import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

    if (typeof window === "undefined") return;

    let wowInstance;

    const initWOW = async () => {
      const WOWModule = await import("wowjs");
      const WOW = WOWModule.default?.WOW || WOWModule.WOW;

      if (!WOW) return;

      // ❌ DO NOT reuse old instance
      if (window.__WOW_INSTANCE__) {
        window.__WOW_INSTANCE__.scrollHandler = null;
        window.__WOW_INSTANCE__.scrollCallback = null;
        window.__WOW_INSTANCE__ = null;
      }

      wowInstance = new WOW({
        live: true, // 🔥 IMPORTANT
        mobile: true,
        resetAnimation: true,
      });

      wowInstance.init();

      window.__WOW_INSTANCE__ = wowInstance;
    };

    initWOW();

  }, [location.pathname]);

  return children;
};

export default ScrollToTop;